import { useEffect, useState } from "react";
import CustomSelect from "../../../common/interactive/CustomSelect";
import { useSelector } from "react-redux";
import { filterPracticesBasedOnUser, reduceToIdArray } from "../../../../lib/script";

export default function SingleOptionV2({filtersValues, item, options, mainSelectAction, classes, workQ}) {
    const user = useSelector(state => state.user.user)
    const [proccesedOptions, setProccessedoptions] = useState(options)

    const [hideItem, setHideItem] = useState(false)
    useEffect(() => {
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) { //we have a rigid filter!!!
                setHideItem(true)
            }
        }
    }, [workQ, item])


    // useEffect(() => {
    //     if (user && user.locations && user.locations.length && item.key == 'practice') {
    //         let userLocations = reduceToIdArray(user.locations)
    //         let newOptions = filterPracticesBasedOnUser(options, userLocations)
    //         setProccessedoptions(newOptions)
    //     }
    // }, [item, options])


    return <>
        {!hideItem && <div className={classes.row}>
            <CustomSelect preSelectedValue={filtersValues && filtersValues[item.key]} optionsData={proccesedOptions} label={item.label} identifier={{type: item.key}} action={mainSelectAction} hasRemove={true}/>         
        </div>}
    </>
}